<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" v-if="patient">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
    <PatientCancellationWarning :patient="patient" v-if="patient.right_to_erasure_requested_at != undefined"/>
      <div class="profile-info d-flex flex-column flex-sm-row align-items-baseline justify-content-between gap-3">
        <div class="m-0" v-if="minimal">
          <h1 class="text-black fw-medium mb-0 h2">{{ patient.firstname }} {{ patient.lastname }}</h1>
        </div>
        <!-- <span class="d-block text-dark-emphasis mb-0 small">
          {{ patient.id }}
        </span> -->
      </div>
      <template v-if="!minimal">
        <!-- <div class="border-top mt-15 mb-15"></div> -->

        <ul class="info px-2 mb-0 list-unstyled row" id="patient-anagraph-info">
          <li class="position-relative col-lg-6 col-xxl-4">
            <div class="icon text-success rounded-circle text-center">
              <i class="ph ph-envelope-simple"></i>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.email.label') }}</span>
            <a :href="`mailto:${email}`" class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
              {{ email }}
            </a>
          </li>
          <li class="position-relative col-lg-6 col-xxl-4" v-if="(patient.self_registration ?? false) === false">
            <div class="icon text-warning-light rounded-circle text-center">
              <i class="ph ph-phone"></i>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.phone.label') }}</span>
            <a :href="`tel:${phone}`" class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
              {{ phone }}
            </a>
          </li>
          <li class="position-relative col-lg-6 col-xxl-4" v-if="(patient.self_registration ?? false) === false">
            <div class="icon text-info rounded-circle text-center">
              <i class="ph ph-calendar-blank"></i>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.birth_date.label') }}</span>
            <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
              {{ patient.birthdate }}
            </span>
          </li>
          <li class="position-relative col-lg-6 col-xxl-4" v-if="(patient.self_registration ?? false) == false">
            <div class="icon text-danger rounded-circle text-center">
              <i :class="'ph ph-gender-' + `${getGenderIcon(patient.sex)}`"></i>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.gender.label') }}</span>
            <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
              {{ patient.sex != null ? $t(`form.gender.${patient.sex}`) : '' }}
            </span>
          </li>
          <li class="position-relative col-lg-6 col-xxl-4" v-if="!((center(patient.center_id)?.is_custom_center ?? false) == true || (patient.self_registration ?? false) == true)">
            <div class="icon text-primary rounded-circle text-center">
              <i class="ph ph-first-aid"></i>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.center_id.label') }}</span>
            <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
              {{ center(patient.center_id)?.name ?? patient.center_id }}
            </span>
          </li>
          <li class="position-relative col-lg-6 col-xxl-4"  v-if="(patient.self_registration ?? false) == false">
            <div class="icon text-muted rounded-circle text-center">
              <i class="ph ph-map-pin"></i>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.address.label') }}</span>
            <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
              {{ patient.address }}, {{ patient.city }}, {{ patient.region }} - {{ patient.zipcode }} - {{
                patient.country
              }}
            </span>
          </li>
        </ul>
        <!-- EXTRA DEFINITIONS -->
        <section v-if="showExtraDefinitions && definitions != undefined" class="d-flex flex-column">
          <div v-for="definition in definitions" :key="definition.dataextra_schema_name">
            <div v-if="!hideExtraDefinitionBlock(definition)" class="mt-3">
              <h5>{{ definition.dataextra_scheme.description }}</h5>
              <div class="values d-flex flex-column gap-1">
                <div v-for="(value, key) in definition.dataextra_scheme.definitions" :key="key"
                  class="d-flex flex-column">
                  <template v-if="!hideAnswer(definition, value.name)">
                    <div class="d-flex align-items-baseline flex-column">
                      <strong>{{ getDefinition(definition, value.name)?.description }}</strong>
                      <!--<span class="d-inline fs-12 text-muted fw-normal d-block">{{ getDefinition(definition, value.name)?.description }}</span>-->
                    </div>
                    <span class="fs-md-15 fs-lg-16 text-muted">
                      <template
                        v-if="getDefinition(definition, value.name)?.type === 'number' || getDefinition(definition, value.name)?.type === 'text' || getDefinition(definition, value.name)?.type === 'textarea' || getDefinition(definition, value.name)?.type === 'range'">
                        {{ definition.dataextra_value[value.name] }}
                      </template>
                      <template
                        v-else-if="getDefinition(definition, value.name)?.type === 'select' || getDefinition(definition, value.name)?.type === 'radio' || getDefinition(definition, value.name)?.type === 'checkbox'">
                        {{getDefinition(definition, value.name)?.options?.find((option) => option.value ===
                          definition.dataextra_value[value.name])?.text}}
                      </template>
                      <template v-else-if="getDefinition(definition, value.name)?.type === 'date'">
                        {{ YYYYMMDD(definition.dataextra_value[value.name] as string) }}
                      </template>
                      <template v-else-if="getDefinition(definition, value.name)?.type === 'select-text'">
                        <template
                          v-for="(text, option) in (definition.dataextra_value[value.name] as ExtraResponseTextSelect)"
                          :key="option">
                          <strong>{{getDefinition(definition, value.name)?.options?.find((choice) => choice.value ===
                            option)?.text}}</strong>: {{ text }}<br>
                        </template>
                      </template>
                    </span>
                  </template>
                </div>
                <!--<div v-for="(value, key) in definition.dataextra_value" :key="key" class="d-flex flex-column">
                  <template v-if="!hideExtraValue(getDefinition(definition, key)!, value)">
                    <strong>{{ getDefinition(definition, key)?.description }}</strong>
                    <span class="fs-md-15 fs-lg-16 text-muted">
                      <template
                        v-if="getDefinition(definition, key)?.type === 'number' || getDefinition(definition, key)?.type === 'text' || getDefinition(definition, key)?.type === 'textarea' || getDefinition(definition, key)?.type === 'range'">
                        {{ value }}
                      </template>
                      <template
                        v-else-if="getDefinition(definition, key)?.type === 'select' || getDefinition(definition, key)?.type === 'radio' || getDefinition(definition, key)?.type === 'checkbox'">
                        {{ getDefinition(definition, key)?.options?.find((option) => option.value === value)?.text }}
                      </template>
                      <template v-else-if="getDefinition(definition, key)?.type === 'date'">
                        {{ YYYYMMDD(value as string) }}
                      </template>
                      <template v-else-if="getDefinition(definition, key)?.type === 'select-text'">
                        <template v-for="(text, option) in (value as ExtraResponseTextSelect)" :key="option">
                          <strong>{{ getDefinition(definition, key)?.options?.find((choice) => choice.value ===
                            option)?.text }}</strong>: {{ text }}<br>
                        </template>
                      </template>
                    </span>
                  </template>
                </div>-->
              </div>
            </div>
          </div>
        </section>
        <div class="d-flex justify-content-end mb-10 mt-10">
          <!-- <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('form.section.personal_information') }}</h5> -->
          <!-- <span></span> -->
          <router-link v-if="updateEnabled" :to="{ path: `/patient/${patient.id}/caregivers` }"
            class="d-inline-flex text-decoration-none lh-1 text-muted fw-medium gap-2 align-items-end mx-1">
            <i class="ph-duotone ph-user-list text-black fs-16"></i>
            {{ $t('page.caregivers') }} {{ caregivers.length !== 0 ? `[${caregivers.length}]` : '' }}
          </router-link>
          <router-link v-if="updateEnabled" :to="{ path: `/patient/${patient.id}/edit` }"
            class="d-inline-flex text-decoration-none lh-1 text-muted fw-medium gap-2 align-items-end mx-1">
            <i class="ph-duotone ph-pencil text-black fs-16"></i>
            {{ $t('cta.edit') }}
          </router-link>
          <div class="mx-1">
            <DownloadPatientData v-if="patient.id != null" :patient_id="patient.id!"></DownloadPatientData>
          </div>

        </div>

      </template>
    </div>
  </div>
</template>

<style lang="scss">
#patient-anagraph-info {
  row-gap: 1rem;

  li {
    margin-bottom: 0;
  }
}
</style>

<script lang="ts">
import { CenterWithPermission, ExtraResponseTextSelect, PatientExtraDefinition, PatientExtraDefinitionValue, PatientExtras, PatientInfo, Role, UserInfo } from "@/utils/models/user.model";
import { getGenderIcon } from "@/utils/const/gender_icon";
import stateStore from "@/utils/store";
import { defineComponent } from "vue";
import CONFIG from '@/utils/const/config';
import { i18n } from '@/assets/i18n/i18n';
import DateFormatUtils from "@/utils/methods/date_formats";
import dayjs from "dayjs";
import API from "@/services/api/api.service";
import DownloadPatientData from "@/components/FK/PatientDetail/DownloadPatientData.vue";
import PatientCancellationWarning from "@/components/FK/PatientDetail/PatientCancellationWarning.vue";

interface PetientExtraDefinitionValueWithSchema extends PatientExtraDefinitionValue {
  dataextra_scheme: PatientExtras
}

export default defineComponent({
  name: "PatientAnagraph",
  components: {
    DownloadPatientData,
    PatientCancellationWarning
  },
  props: {
    minimal: {
      type: Boolean,
      default: false
    },
    show_extra_definitions: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      definitions: undefined as undefined | PetientExtraDefinitionValueWithSchema[]
    }
  },
  computed: {
    config() { return CONFIG },
    patient() { return this.$route.meta.patient as PatientInfo },
    caregivers(): UserInfo[] { return this.patient.users?.filter((info) => info.role.type === Role.caregiver) ?? []; },
    email() { return (this.$route.meta.patient as PatientInfo)!.users![0].email ?? '' },
    phone() { return (this.$route.meta.patient as PatientInfo)!.users![0].phone_number ?? '' },
    updateEnabled(): boolean { return stateStore.getCenterPermission((this.$route.meta.patient as PatientInfo).center_id, 'update') },
    showExtraDefinitions(): boolean {
      return this.config.feature.extra_definitions === true && this.show_extra_definitions;
    }
  },
  mounted() {
    if (this.showExtraDefinitions) {
      this.getExtraDefinitions();
    }
  },
  methods: {
    getExtraDefinitions() {
      Promise.all([
        API.getExtraDefinitions('patients', { lang: i18n.global.locale }),
        API.getExtraDefinitionValues({ entity: 'patients', entity_id: this.patient.id! })
      ]).then((responses) => {
        if (responses.every((res) => res.data.success === true)) {
          let definitions = responses[0].data.data;
          let values = responses[1].data.data;

          let temp_defs = definitions.filter((value: PatientExtras) => values.find((def: PatientExtraDefinitionValue) => def.dataextra_schema_name === value.schema_name) !== undefined);
          this.definitions = temp_defs.map((value: PatientExtras) => {
            return {
              dataextra_schema_name: value.schema_name,
              dataextra_scheme: value,
              dataextra_value: values.find((def: PatientExtraDefinitionValue) => def.dataextra_schema_name === value.schema_name)!.dataextra_value
            } as PetientExtraDefinitionValueWithSchema
          });
        }
      });
    },
    center(id: number): CenterWithPermission | undefined {
      return stateStore.getCenter(id);
    },
    sendMessage() {
      this.$router.push({ path: `/messages/${this.patient.id}` });
    },
    getDefinition(definitions: PetientExtraDefinitionValueWithSchema, key): PatientExtraDefinition | undefined {
      return definitions.dataextra_scheme.definitions.find((def) => def.name === key);
    },
    YYYYMMDD(date: string) {
      return DateFormatUtils.YYYYMMDD(dayjs(date).toDate());
    },
    hideExtraValue(definition: PatientExtraDefinition, value: string | number | ExtraResponseTextSelect) {
      if (definition.type === 'text' || definition.type === 'textarea' || definition.type === 'number' || definition.type === 'range' || definition.type === 'date') {
        return value === '';
      }
      if (definition.type === 'checkbox' || definition.type === 'radio' || definition.type === 'select') {
        return value === '-1';
      }
      if (definition.type === 'select-text') {
        return Object.keys(value as ExtraResponseTextSelect).includes('-1');
      }
    },
    hideAnswer(definition: PetientExtraDefinitionValueWithSchema, key: string) {
      let value = definition.dataextra_value[key];
      let type = definition.dataextra_scheme.definitions.find((el) => el.name === key)?.type;
      if (value === undefined || type === undefined) return true;
      if (type === 'text' || type === 'textarea' || type === 'number' || type === 'range' || type === 'date') {
        return value === '';
      }
      if (type === 'checkbox' || type === 'radio' || type === 'select') {
        return value === '-1';
      }
      if (type === 'select-text') {
        return Object.keys(value as ExtraResponseTextSelect).includes('-1');
      }
    },
    hideExtraDefinitionBlock(definition: PetientExtraDefinitionValueWithSchema) {
      Object.keys(definition.dataextra_value).forEach((key) => {
        let value = definition.dataextra_value[key];
        console.log(key, value);
      });
      return Object.keys(definition.dataextra_value).every((key) => this.hideExtraValue(this.getDefinition(definition, key)!, definition.dataextra_value[key]))
    },
    getGenderIcon(sex: number): string {
      return getGenderIcon(sex);
    }
  }
});
</script>